'use client';

import { useEffect, useState } from 'react';

import { SIDEBAR_WIDTH_DESKTOP, SIDEBAR_WIDTH_TABLET } from '@shaojiang/config';
import useBreakpoints from '@shaojiang/hooks/useBreakpoints';
import { useDomStore } from '@shaojiang/store/dom';

export function useSidebar() {
  const setMobileSidebarOpen = useDomStore((state) => state.setMobileSidebarOpen);
  const { xlDown, mdDown } = useBreakpoints();
  // Tablet widths default to the mini sidebar; the user can toggle it on desktop only.
  const isTablet = xlDown && !mdDown;
  const [userMini, setUserMini] = useState<boolean | null>(null);
  const showMini = isTablet || (!xlDown && !!userMini);

  const toggleShowMini = () => setUserMini(!showMini);

  useEffect(() => {
    if (!mdDown) {
      setMobileSidebarOpen(false);
    }
  }, [setMobileSidebarOpen, mdDown]);

  return {
    sidebarWidth: showMini ? SIDEBAR_WIDTH_TABLET : SIDEBAR_WIDTH_DESKTOP,
    xlDown,
    mdDown,
    showMini,
    toggleShowMini,
  };
}
